import '@fontsource/roboto/latin.css';
import { createTheme } from '@mui/material';
import { CustomPalette } from '../types';
import componentStyles from './components';
import { typography } from './typography';

const theme = (palette: CustomPalette) => {
  const components = componentStyles(palette);
  return createTheme({
    components,
    palette,
    typography,
  });
};

export default theme;
